import * as React from 'react';
import { FooterContainer, FooterContent, FooterLink } from '../../components/UI/FooterUI';
import Routes from '../../constants/Routes';

const Footer: React.SFC = () => (
  <FooterContainer>
    <FooterContent>
      <div>
        <h3>Coinmend</h3>
        <p>&copy; 2018</p>
      </div>
      <div>
        <h4>Column 1</h4>
        <ul>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
        </ul>
      </div>
      <div>
        <h4>Column 2</h4>
        <ul>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
        </ul>
      </div>
      <div>
        <h4>Company</h4>
        <ul>
          <li>
            <FooterLink to={Routes.about}>About</FooterLink>
          </li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
          <li>List Item</li>
        </ul>
      </div>
      <div>
        <h4>Resources</h4>
        <ul>
          <li>
            <FooterLink to={Routes.privacy}>Privacy</FooterLink>
          </li>
          <li>
            <FooterLink to={Routes.terms}>Terms</FooterLink>
          </li>
        </ul>
      </div>
    </FooterContent>
  </FooterContainer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Site/Footer.tsx